import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
    workspaceRoot: {
       display: 'block',
       position: 'relative',
       width: '100%',
       height: '100%',
       overflow: 'hidden',
    },

    canvasSpace: ({ shadow, transparent, shape }) => {
        const style = {
            boxSizing: 'border-box',
            position: 'absolute',
            display: 'block',
            width: '100%',
            height: '100%',
            cursor: 'move',
            backgroundColor: '#FFFFFF',
            // border: '1px solid #A3A3A3', // don't add border to the canvas space, it affects the image results
            overflow: 'visible',
        };

        if (transparent) {
            style.backgroundColor = '#FFFFFF00';
        }

        if (shadow) {
            // style.boxShadow = '0px 6px 6px 0px #00000066';
            style.filter = 'drop-shadow(0px 5px 5px  #00000066)';
        }

        if (shape === 'round' && transparent) {
            style.outline = '1px solid #A3A3A388';
        }

        return style;
    },

    canvas: ({ shape }) => {
        const style = {
            cursor: 'move',
            postion: 'absolute',
            boxSizing: 'border-box',
        };

        return style;
    },

    crosshair: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        color: '#A3A3A3',
        pointerEvent: 'none',
    },

    crossLine: {
        strokeLinecap: 'square',
        strokeWidth: '1',
        stroke: '#A3A3A399',
    },

    resizer: {
        position: 'absolute',
        display: 'block',
    },

}));
